(function() {
    'use strict';

    function initInfographic() {
        const sections = document.querySelectorAll('.infographic-section');
        const contentBoxes = document.querySelectorAll('.infographic-content-box');

        console.log('Infographic initialized');
        console.log('Sections found:', sections.length);
        console.log('Content boxes found:', contentBoxes.length);

        if (!sections.length || !contentBoxes.length) {
            console.warn('Missing sections or content boxes');
            return;
        }

        // Hide all content boxes initially
        contentBoxes.forEach(box => {
            box.classList.remove('visible');
        });

        // Add hover event listeners to each section
        sections.forEach(section => {
            section.addEventListener('mouseenter', function() {
                const sectionName = this.getAttribute('data-section');

                // Remove active class from all sections
                sections.forEach(s => s.classList.remove('active'));
                
                // Add active class to current section
                this.classList.add('active');

                // Hide all content boxes
                contentBoxes.forEach(box => {
                    box.classList.remove('visible');
                });

                // Show the relevant content box
                const relevantBox = document.querySelector(`.infographic-content-box[data-content="${sectionName}"]`);
                console.log('Looking for content box:', sectionName, relevantBox);
                if (relevantBox) {
                    relevantBox.classList.add('visible');
                    console.log('Added visible class to:', sectionName);
                }
            });

            section.addEventListener('mouseleave', function() {
                // Optional: Keep content visible or hide it
                // Comment out the following lines if you want content to stay visible after hover
                this.classList.remove('active');
                contentBoxes.forEach(box => {
                    box.classList.remove('visible');
                });
            });
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initInfographic);
    } else {
        initInfographic();
    }
})();
